export const DEALER_LOCATOR_ENDPOINT =
  "/dealer-showrooms/:makeMaskingName([a-zA-Z0-9-]+)/:cityMaskingName([a-zA-Z0-9-]+)/";

export const AD_SLOTS = {
  TOP_AD: {
    id: "div-gpt-ad-1439110989763-0",
    path: "/1017752/Carwale_Dealers_970x90",
    size: [
      [220, 90],
      [728, 90],
      [950, 90],
      [960, 90],
      [970, 66],
      [970, 90],
      [960, 60],
      [970, 60],
    ],
  },
  MIDDLE_AD: {
    id: "div-gpt-ad-5381711-0",
    path: "/1017752/NewCar_DealerLocater_300x250",
    size: [[300, 250]],
  },
  BOTTOM_AD: {
    id: "div-gpt-ad-1586172472122-0",
    path: "/1017752/Carwale_DSK_DealerLocator_Bottom_970x90",
    size: [
      [970, 60],
      [728, 90],
      [970, 66],
      [950, 90],
      [220, 90],
      [970, 90],
      [960, 60],
      [960, 90],
    ],
  },
};
